import FormErrors from "@/components/FormErrors/FormErrors";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import uuidv4 from "uuid/v4";
import { JSConn } from "@/utilities/js-conn";

export default {
  name: "lotUnitEditForm",
  components: {
    FormErrors,
    LoadingAnimation,
  },
  props: {
    lotUnitId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Lot Unit...",
      hasFormErrors: false,
      cancelParams: { name: "lotUnits" },
      formErrors: [],
      lotUnit: {
        name: null,
        description: null,
      },
    };
  },
  created() {
    if (this.lotUnitId === "new") {
      this.lotUnit = {
        id: uuidv4(),
        name: "New",
        description: "",
      };
      this.dataLoaded = true;
      this.$nextTick(() => this.$refs.firstInput.select());
    } else {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: this.lotUnitId,
      };

      this.$store.dispatch("needLotUnit", jsConn).then(() => {
        // correct lot unit is in the store
        this.lotUnit = {
          name: this.apiLotUnit.name,
          description: this.apiLotUnit.description,
          id: this.apiLotUnit.id,
        };
        this.dataLoaded = true;
        this.cancelParams = {
          name: "lotUnits",
        };
        this.$nextTick(() => this.$refs.firstInput.select());
      });
    }
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();
      jsConn.formParams = this.lotUnit;
      jsConn.toRoutePath = "/lot-units";

      let storeDispatch;

      if (this.lotUnitId === "new") {
        storeDispatch = "createLotUnit";
      } else {
        storeDispatch = "updateLotUnit";
      }

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(jsConn => {
          this.$router.push(jsConn.toRoutePath);
          return Promise.resolve(jsConn);
        })
        .catch(jsConn => {
          this.hasFormErrors = true;
          this.formErrors = jsConn.error["response"]["data"];
        });
    },
    showDeleteModal() {
      this.$refs["deleteModal"].show();
    },
    hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },
    deleteLotUnit() {
      const jsConn = new JSConn();
      jsConn.toRoutePath = "/lot-units";
      jsConn.formParams = {
        id: this.lotUnitId,
      };
      this.$store.dispatch("deleteLotUnit", jsConn).then(jsConn => {
        this.$router.push(jsConn.toRoutePath);
        return Promise.resolve(jsConn);
      });
    },
  },
  computed: {
    apiLotUnit: function() {
      return this.$store.getters.lotUnit;
    },
  },
};
